<template>
    <app-page-error v-if="isAnonymous" />
    <content-with-side-menu v-else @show-cookies="$emit('show-cookies')">
        <template #side-menu v-if="!isGuest">
            <mq-layout mq="tablet+">
                <n-dashboard-side-menu class="is-hidden-mobile" :folders="folders"/>
                <!--<dashboard-side-menu class="is-hidden-mobile" v-else />-->
            </mq-layout>
        </template>
        <template #main-content>
            <mq-layout mq="mobile">
                <dashboard-top-menu />
            </mq-layout>
            <router-view @folderCreated="refreshFolders" @folderUpdated="refreshFolders"></router-view>
        </template>
    </content-with-side-menu>
</template>

<script>
import NDashboardSideMenu from '@/components/NDashboardSideMenu';
import DashboardTopMenu from '@/components/DashboardTopMenu';
import ContentWithSideMenu from '@/layouts/ContentWithSideMenu';
import { fetchItems } from '@/services/API';
import AppPageError from '@/components/AppPageError';

export default {
    components: {
        DashboardTopMenu,
        ContentWithSideMenu,
        NDashboardSideMenu,
        AppPageError
    },
    data() {
        return {
            folders: [],
        };
    },
    mounted() {
        //this.$store.dispatch('fetchMyCommunities'); //force communities fetch to render side menu option
        // console.log(this.$store.getters.isAnonymous)
        // console.log("enter in dashboard", this.$store.getters.activePlan, this.$store.getters.projectsNumber, this.$store.getters.canCreateProject)
        //if (!this.$store.getters.canCreateProject) {
            // console.log('emiting check plan')
            this.$emit("checkPlan");
        //}
        this.fetchFolders();
        /*if (this.$store.getters.personalData.invitation) {
            alert("unvutación pendiente")
        }*/
    },
    computed: {
        isAdmin() {
            return this.$store.getters.isAdmin;
        },
        isAnonymous() {
            return this.$store.getters.isAnonymous;
        },
        isGuest() {
            let isGuest=false;
            if (this.isAdmin) {
                return false;
            }
            if (this.$store.getters.user.entities) {
                // console.log("checking entities permissions")
                this.$store.getters.user.entities.forEach(element => {
                    
                    if ((element.entity._id == this.$store.getters.user.school._id) && (element.permission == 'GUEST')) {
                        // console.log("is guest")
                        isGuest = true;
                    } /*else {
                        console.log("not guest")
                        isGuest = false;
                    }*/
                });
            } else {
                // console.log("not guest 2")
                isGuest = false;
            }
            return isGuest;
            //return this.isAdmin
        }
    },
    metaInfo() {
        return {
            title: 'Dashboard',
            titleTemplate: '%s - eduloc360',
        };
    },
    methods: {
        async fetchFolders() {
            const folders = await fetchItems('folder');
            this.folders = folders.data;
        },
        refreshFolders(){
            this.fetchFolders();
        }
    },
};
</script>

<style scoped lang="scss"></style>
